import { render, staticRenderFns } from "./PartCardItem.vue?vue&type=template&id=2dd0eb26&scoped=true"
import script from "./PartCardItem.ts?vue&type=script&lang=ts&external"
export * from "./PartCardItem.ts?vue&type=script&lang=ts&external"
import style0 from "./PartCardItem.scss?vue&type=style&index=0&id=2dd0eb26&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0eb26",
  null
  
)

export default component.exports